//hamburger
const hamburger = document.getElementById('hamburger');
hamburger.addEventListener('click', function () {
	hamburger.parentNode.classList.toggle('open');
	document.documentElement.classList.toggle('is-active');
});

//inview
//const slideIn = document.querySelectorAll('.slideIn');
/* intersectAction(slideIn, function (element, isIntersecting) {
	if (isIntersecting) {
		element.classList.add('isShow');
	}
}) */

//slideInもしくは underlineSlideというクラス名がある時だけisShowクラスを付与
const slideIn = document.getElementsByClassName('slideIn');
const underlineTargets = document.getElementsByClassName('underlineSlide');
const underlineLeadTargets = document.getElementsByClassName('underLineAnimeLead');
const verticalAnimeTargets = document.getElementsByClassName('verticalMoveAnime');

const options = {
  rootMargin: "0% 0%",
  threshold: 0,
};

let observer = new IntersectionObserver(showElements, options);

// --- もともとの .slideIn（全ページ共通） ---
for (let i = 0; i < slideIn.length; i++) {
  observer.observe(slideIn[i]);
}

// ==============================
//   LP（body.cm-edoors）だけで発火
// ==============================
const isServicePage = document.body.classList.contains('cm-edoors');

if (isServicePage) {

  // .underlineSlide
  for (let i = 0; i < underlineTargets.length; i++) {
    observer.observe(underlineTargets[i]);
  }

  // .underLineAnimeLead
  for (let i = 0; i < underlineLeadTargets.length; i++) {
    observer.observe(underlineLeadTargets[i]);
  }

  // .verticalMoveAnime
  for (let i = 0; i < verticalAnimeTargets.length; i++) {
    observer.observe(verticalAnimeTargets[i]);
  }

}

function showElements(entries) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('isShow');
    }
  });
}


//タブ
document.addEventListener('DOMContentLoaded', function () {
	//要素を設定
	const tabBtn = document.getElementById("tabBtn");
	if (tabBtn !== null) {
		//要素を設定
		const target = tabBtn.nextElementSibling;
		//子要素を設定
		let item = tabBtn.children;
		let targetItem = target.children;
		for (let i = 0; i < item.length; i++) {
			item[i].addEventListener('click', function () {

				//リセット
				for (let i = 0; i < item.length; i++) {
					item[i].classList.remove('active');
					targetItem[i].style.maxHeight = null;
				}
				//アクティブ
				item[i].classList.add('active');
				targetItem[i].style.maxHeight = targetItem[i].scrollHeight + "px";

			});
		}
		item[0].classList.add('active');
		targetItem[0].style.maxHeight = targetItem[0].scrollHeight + "px";
	}
});

//Serveice aside nav
const serviceSection = document.getElementById('serviceTop');
const sideNav = document.getElementById('sideNav');
if (sideNav) {
	function sideNavSet() {
		if (sideNav !== null) {
			let h = sideNav.offsetHeight * -1 - 14;
			serviceSection.style.marginTop = h + 'px';
		}
	}

	document.addEventListener('DOMContentLoaded', function () {
		sideNavSet();
	});

	window.addEventListener('resize', function () {
		const windowWidth = window.innerWidth; // ブラウザウィンドウの幅を取得
		if (windowWidth > 1280) {
			sideNavSet();
		} else {
			serviceSection.style.marginTop = '0px';
		}
	});
}



// 下部固定ボタン（.cm-edoor__fixed-btn）があるページだけで動かす
document.addEventListener("DOMContentLoaded", function () {
  const target = document.querySelector(".cm-edoor__fixed-btn, .cm-lp__fixed-btn");
  const showPos = 1000; // 表示開始位置 px

  // 対象要素がないページでは何もしない
  if (!target) return;

  // 初期状態は非表示
  target.style.display = "none";
  target.style.opacity = 0;
  target.style.transition = "opacity 0.3s";

  let isVisible = false;

  function updateFixedBtn() {
    const scrollTop = window.scrollY || window.pageYOffset;

    if (scrollTop > showPos) {
      if (!isVisible) {
        target.style.display = "block";
        requestAnimationFrame(() => {
          target.style.opacity = 1;
        });
        isVisible = true;
      }
    } else {
      if (isVisible) {
        target.style.opacity = 0;
        setTimeout(() => {
          target.style.display = "none";
        }, 300);
        isVisible = false;
      }
    }
  }

  window.addEventListener("scroll", updateFixedBtn);

  // ★ ブラウザバック時にも実行させる（BFCache対応）
  window.addEventListener("pageshow", function (event) {
    // event.persisted が true なら BFCache から復元された
    updateFixedBtn();
  });

});


// 固定ボタンを下記LPだけ下部フォームに移動に変更
(() => {
  const allowedPaths = new Set([
    '/pages/growth-analysis',
    '/pages/cross-platform-analysis',
  ]);
  if (!allowedPaths.has(window.location.pathname)) return;

  document.addEventListener('click', (e) => {
    const link = e.target.closest('.floating a');
    if (!link) return;

    const target = document.querySelector('.cm-lp-content__form');
    if (!target) return;

    e.preventDefault();

    // ▼ページ内移動時の見出し隠れ防止用のオフセット
    const offset = -180; // -180〜-220で調整

    const y = target.getBoundingClientRect().top + window.pageYOffset + offset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });
})();


// =========================================
// 資料ページ（body.cm-document）だけで発火
// 「ダウンロードページへ進む」を直接遷移にする
// =========================================
document.addEventListener('DOMContentLoaded', function () {

  if (!document.body.classList.contains('cm-document')) return;

  document.addEventListener('click', function (e) {

    const btn = e.target.closest('#confirmation-wrapper .hidden-submit');
    if (!btn) return;

    e.preventDefault();

    let redirectUrl = '';

    document.querySelectorAll('script').forEach((script) => {
      const text = script.textContent || '';

      if (
        text.includes("location.hash.match('contact_form')") &&
        text.includes('location.href')
      ) {
        const match = text.match(/location\.href\s*=\s*['"]([^'"]+)['"]/);
        if (match && match[1]) {
          redirectUrl = match[1];
        }
      }
    });

    if (redirectUrl) {
      location.href = redirectUrl;
    }

  }, true);

});

document.addEventListener('DOMContentLoaded', ()=>{
  const accordions = document.querySelectorAll('.js-cm-accordion');
  if(accordions.length > 0) {
    accordions.forEach(accordion => {
      function accordion_activate(accordion) {
      const button = accordion.querySelector('.js-cm-accordion-button');
      const content = accordion.querySelector('.js-cm-accordion-content');
      button.addEventListener('click', () => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', !isExpanded);
        content.setAttribute('aria-hidden', isExpanded);
      });
    }
      if(accordion.classList.contains('accordion-active-mobile')) {
        if(window.innerWidth < 750) {
          accordion_activate(accordion);
        } else {
          accordion.querySelector('.cm-accordion-menu').removeAttribute('aria-hidden');
        }
      } else if(accordion.classList.contains('accordion-active-desktop')) {
        if(window.innerWidth >= 750) {
          accordion_activate(accordion);
        }
      } else {
        accordion_activate(accordion);
      }
    });
  }
});